import React, { useContext, useEffect, useMemo, useState } from "react";
import { Box, Button, Grid, IconButton, Paper, Typography } from "@mui/material";
import brokerApi from "../../../api/brokerApi";
import RtlProvider from "../../../Components/RtlProvider";
import { ContextNotification, severitys } from "../../../App";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import helper from "../../../helper";

import { ContextUserInfo } from "../MainPanel";
import AccessControl from "../../../Components/AccessControl";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MdCheck } from "react-icons/md";
import { HiXMark } from "react-icons/hi2";

const BrokerPanel = () => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const { open, setOpen } = useContext(ContextNotification);
  // const [rows, setRows] = useState([]);
  const [data, setData] = useState([])
  const [Brokers, SetBrokers] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loadingRows, setLoadingRows] = useState(false);

  const schema = yup.object().shape({
  });
  const { handleSubmit, formState: { errors }, control } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {

    if (data?.brokerId) {
      brokerApi.GetByKey(data.brokerId)
        .then((res) => {
          const result = [];
          result.push(res.data.data)
          setData(result)
        })
        .catch((error) => console.log(error));
    }
    else {
      GetData();
    }
  };

  useEffect(() => {
    GetBrokerDropDown();
    GetData();
  }, [refresh]);

  const GetData = () => {
    setLoadingRows(true);
    brokerApi.GetAll()
      .then((data) => {
        setData(data.data.data)
      })
      .catch((error) => console.log(error))
      .finally(() => setLoadingRows(false));
  }
  const RefreshGrid = (result) => {
    if (result)
      setRefresh(old => !old);
  }
  const GetBrokerDropDown = () => {
    brokerApi
      .BrokerDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        SetBrokers(arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        }))
      })
      .catch((error) => console.log(error));
  };
  const handleBrokerChanged = (id) => { };

  const columns = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: 'نام',
        size: 100,
      },
      {
        accessorKey: 'code',
        header: 'کد',
        size: 100,
      },

      {
        accessorKey: 'isActive',
        id: 'isActive',
        header: 'فعال',
        Cell: ({ cell, row }) => (
          row.original.isActive ? <MdCheck size={25} color='green' /> : <HiXMark />
        ),
        size: 100,
        enableSorting: false,
      },

    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data,
    initialState: {
      sorting: [

      ],
    },
    state: {
      isLoading: loadingRows,
    },
    enableRowSelection: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enablePagination: false,
    enableSorting: true,
    enableColumnActions: false,

    mrtTheme: (theme) => ({
      baseBackgroundColor: theme.palette.background.default, //change default background color
    }),

    muiTableProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',

      },
    },
    muiTableHeadCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        backgroundColor: '#86A7FC',
        fontWeight: 'bold',
        textAlign: 'left'
      },
    },
    muiTableBodyCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        textAlign: 'left'
      },
    },
    enableRowActions: false,
    positionActionsColumn: 'last',
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: '', //change header text
        size: 300, //make actions column wider

      },
    },
    renderRowActions: ({ row, table }) => (

      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>


      </Box>
    ),
  });


  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <RtlProvider>
        <Typography component="h1" variant="h5" mb={2}>
          لیست کارگزار
        </Typography>
        <Grid container spacing={1} mb={2}>
          <Grid item xs={12} sm={3}>
            <RHFAutocomplete
              control={control}
              options={Brokers ?? []}
              name="brokerId"
              placeholder="کارگزار"
              onChange={handleBrokerChanged}
            />
          </Grid>
          <Grid item xs={12} sm={1}>
            <Button type="submit" variant="contained" color="secondary">جستجو</Button>
          </Grid>
        </Grid>
        <MaterialReactTable table={table} />
      </RtlProvider>
    </form>
  );
}

export default BrokerPanel;
